<template>
    <div class="day-selector">
        <button
            v-for="(day, index) in weekDays"
            :key="index"
            :class="{ active: day.index === currentWeekDay }"
            :disabled="dayIsDisabled(day.index) || day.index === currentWeekDay"
            @click="$emit('selectDay', day.index)"
        >
            {{ $t(day.name) }}
        </button>
    </div>
</template>

<script type="text/babel">
import { daysOfWeek } from './timeWindowHelper';
import { COMPONENT_NAMES } from '../../../../constants';

export default {
    name: COMPONENT_NAMES.DAY_SELECTOR,

    props: {
        currentWeekDay: {
            required: true,
            type: Number,
        },

        dayIsDisabled: {
            required: false,
            type: Function,
            default: () => false,
        },
    },

    data() {
        return {
            weekDays: daysOfWeek,
        };
    },
};
</script>

<style scoped></style>
